

interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const maleenergy: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "male-energy-plus-iv-drip",
        "meta": {
            "title": "Male Energy Plus IV Drip in Dubai | Elite Body Home",
            "description": "Boost physical performance, stamina and overall health with our specialized IV therapy designed specifically for men's vitality needs.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/male-energy-plus-iv-drip/",
            "og": {
                "title": "Male Energy Plus IV Drip in Dubai | Elite Body Home",
                "description": "Specialized IV therapy to enhance male energy, stamina and vitality",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-49.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "Male Energy Plus IV Drip"],
        "hero": {
            "title": "Male Energy Plus IV Drip in Dubai",
            "subtitle": "Vitality Enhancement Therapy",
            "description": "A boost in man's vitality and energy is becoming unavoidable to tackle the woes of a fast-paced lifestyle. The Male Energy Plus IV Drip is formulated to boost physical performance and improve stamina and overall health. This individually designed IV therapy sends essential nutrients and hydration straight into your bloodstream, to be absorbed more quickly and effectively than oral supplements."
        },
        "howItWorks": {
            "title": "How Does Male Energy Plus IV Drip Work?",
            "description": "The Male Energy Plus IV Drip treatment is simple, quick, and painless. This procedure provides a nutrient-rich combination of vitamins, minerals, amino acids, and antioxidants that is then injected through an intravenous infusion directly into the blood for maximum absorption."
        },
        "procedureSteps": {
            "heading": "Procedure Overview",
            "para": "Here's what to expect during your Male Energy Plus IV Drip session:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "A medical professional evaluates your health and energy levels to see whether the treatment is suitable for you.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "Preparation",
                    "desc": "A customized cocktail of vitamins, minerals, and nutrients is prepared to enhance male energy and vitality.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "IV Insertion",
                    "desc": "A medical professional inserts a small, sterile needle into a vein, usually in your arm.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "Infusion Process",
                    "desc": "The drip itself takes 30-60 minutes, delivering nutrients directly into your bloodstream for quick and powerful results.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "Post-Treatment",
                    "desc": "When the IV drip is done, the needle will be taken out, and you can continue your day. Many patients note increased energy immediately after.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of Male Energy Plus IV Drip",
            "subheading": "Experience enhanced physical performance and vitality",
            "para": "Male Energy Plus IV Drip have several benefits for people who want to work on their physical and mental health:",
            "items": [
                {
                    "title": "Increased Energy Levels",
                    "desc": "A drip gives you an instant increase in energy and endurance; perfect for workers, busy professionals, and athletes.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Enhanced Athletic Performance",
                    "desc": "This mixture of vitamins and amino acids can enhance endurance and recovery for your muscles.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Improved Mental Clarity",
                    "desc": "The IV therapy contains antioxidants that combat mental fog and improve focus.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "Hormonal Balance Support",
                    "desc": "Some nutrients in the IV therapy can help your body balance testosterone levels.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Better Hydration",
                    "desc": "Direct infusion of electrolytes makes for better hydration, vital for energy and sustained performance.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Boosted Immune System",
                    "desc": "Helps support your immune system so men can stay active and healthy, even under stressful times.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "Who Can Benefit from Male Energy Plus IV Drip?",
            "subheading": "",
            "para": "This is the perfect treatment for tired, stressed men whose performance has decreased. Ideal candidates include:",
            "items": [
                {
                    "title": "Active Men",
                    "desc": "Most men wanting to improve their physical and mental performance.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Fatigue Sufferers",
                    "desc": "Persons dealing with fatigue or exhaustion.",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "Athletes & Fitness Enthusiasts",
                    "desc": "People currently seeking better recovery with endurance.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "Aging Men",
                    "desc": "Men who are low energy or low T due to age.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "Physically Active Professionals",
                    "desc": "People who need quick and efficient hydration following intense physical activity.",
                    "icon": "fa-solid fa-briefcase"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparation Before Your Treatment",
            "subheading": "",
            "para": "Preparing for a Male Energy Plus IV Drip treatment is easy, however, taking a few steps can help make sure you get the most out of it:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Be well hydrated before your appointment—this will make your veins easier to find and will help you absorb nutrients better.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Eat a Light Meal",
                    "desc": "Eating a light, balanced meal prior to your session can help avoid feeling lightheaded.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Avoid Caffeine & Alcohol",
                    "desc": "Avoid caffeine and alcohol for several hours before your treatment because they can be dehydrating.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Consult with a Professional",
                    "desc": "Review any existing medications or medical conditions with the clinic to ensure you receive treatment that fits your needs.",
                    "icon": "fa-solid fa-comment-medical"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "For men looking to boost vitality, the Male Energy Plus IV Drip offers immediate and progressive benefits. Patients often report:",
            "items": [
                {
                    "title": "Increased Energy",
                    "desc": "Increased energy and stamina immediately after treatment.",
                    "icon": "fa-solid fa-battery-three-quarters"
                },
                {
                    "title": "Mental Clarity",
                    "desc": "Enhanced mental clarity and concentration.",
                    "icon": "fa-solid fa-lightbulb"
                },
                {
                    "title": "Faster Recovery",
                    "desc": "Accelerated post-exercise muscle recovery.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Optimal Hydration",
                    "desc": "Better hydration levels throughout the body.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "Improved Mood",
                    "desc": "Improved mood and lowered stress levels.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maximize and maintain the benefits of your Male Energy Plus IV Drip:",
            "items": [
                {
                    "title": "Hydration Maintenance",
                    "desc": "Continue drinking plenty of water to maintain optimal hydration levels.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Monitor Effects",
                    "desc": "Pay attention to any possible side effects, which are uncommon.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "Regular Sessions",
                    "desc": "Consider regular treatments for sustained energy and vitality benefits.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Healthy Lifestyle",
                    "desc": "Maintain a balanced diet and exercise routine to complement the treatment effects.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "How long does a Male Energy Plus IV Drip session take?",
                    "answer": "The infusion process typically takes between 30-60 minutes."
                },
                {
                    "question": "Is the treatment painful?",
                    "answer": "Patients may feel a small pinch during needle insertion, but the treatment itself is painless."
                },
                {
                    "question": "How soon will I feel the effects?",
                    "answer": "Many patients report feeling increased energy immediately after the session."
                },
                {
                    "question": "How often should I get this treatment?",
                    "answer": "Frequency depends on individual needs - our medical professionals can recommend a schedule during consultation."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Side effects are rare but may include minor bruising at the injection site or lightheadedness."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Male-Energy-Plus-IV-Drip-scaled.jpg",
            "beforeAfter": []
        },
        "product": {
            "id": 37,
            "title": "Male Energy Plus IV Drip in Dubai",
            "description": "Specialized IV therapy to boost male energy, stamina and overall vitality with direct nutrient infusion.",
            "price": 699
        }
    },
    "ar": {
        "url": "male-energy-plus-iv-drip",
        "meta": {
            "title": "تعزيز الطاقة للرجال بالتنقيط الوريدي في دبي | ايليت بودي هوم",
            "description": "علاج متخصص لتعزيز الحيوية والأداء البدني للرجال من خلال تركيبة مغذية تعطى مباشرة في الوريد لتحسين الطاقة والتحمل والصحة العامة.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/male-energy-plus-iv-drip",
            "og": {
                "title": "تعزيز الطاقة للرجال بالتنقيط الوريدي في دبي | ايليت بودي هوم",
                "description": "علاج لتعزيز طاقة الرجال وحيويتهم وأدائهم البدني",
                "image": "https://www.elitebodyhome.com/images/male-energy-iv-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "تعزيز الطاقة للرجال بالتنقيط الوريدي"],
        "hero": {
            "title": "تعزيز الطاقة للرجال بالتنقيط الوريدي",
            "subtitle": "علاج تعزيز الحيوية والأداء البدني",
            "description": "أصبحت الحاجة إلى تعزيز الحيوية والأداء البدني وقوة التحمل لدى الرجال أمراً لا غنى عنه في ظل نمط الحياة السريع الحالي؛ لهذا نقدم لك علاج تعزيز الطاقة للرجال بالتنقيط الوريدي، الذي يتكون من تركيبة متطورة صُممت خصيصاً لتعزيز القوة، وتحسين القدرة على التحمل، والصحة العامة للرجل. تعتمد هذه الجلسة العلاجية على توفير مزيج من الفيتامينات الوريدية والمعادن والسوائل المرطبة مباشرةً إلى مجرى الدم، مما يضمن امتصاصاً سريعاً وفاعلية أعلى مقارنًة بالمكملات الغذائية التي تؤخذ عن طريق الفم."
        },
        "howItWorks": {
            "title": "كيف يعمل علاج تعزيز الطاقة للرجال؟",
            "description": "يُعد علاج تعزيز الطاقة للرجال بالتنقيط الوريدي علاج بسيط وسريع وغير مؤلم. يتضمن تزويد المريض بمزيج غني من الفيتامينات والمعادن والأحماض الأمينية ومضادات الأكسدة مباشرةً في مجرى الدم لضمان أقصى امتصاص."
        },
        "procedureSteps": {
            "heading": "خطوات الإجراء",
            "para": "إليك ما يمكن توقعه خلال جلسة العلاج:",
            "steps": [
                {
                    "title": "استشارة الطبيب",
                    "desc": "يقوم الطبيب المتخصص بتقييم حالتك الصحية ومستويات الطاقة لديك، لتحديد مدى ملاءمة العلاج لك.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "التحضير",
                    "desc": "يُحضر مزيج خاص من الفيتامينات والمعادن والعناصر الغذائية ضمن تركيبة مصممة خصيصًا لتعزيز الطاقة والحيوية لدى الرجال.",
                    "icon": "fa-solid fa-flask"
                },
                {
                    "title": "إدخال الإبرة الوريدية",
                    "desc": "يتم إدخال إبرة صغيرة ومعقمة في الوريد، عادةً في وريد الذراع، من قبل أحد المتخصصين.",
                    "icon": "fa-solid fa-syringe"
                },
                {
                    "title": "التنقيط الوريدي",
                    "desc": "تستغرق الجلسة ما بين 30 إلى 60 دقيقة، ويتم من خلاله إيصال المغذيات مباشرةً إلى مجرى الدم للحصول على نتائج سريعة وقوية.",
                    "icon": "fa-solid fa-clock"
                },
                {
                    "title": "الرعاية اللاحقة",
                    "desc": "تُزال الإبرة عند انتهاء الجلسة، ويمكنك الاستراحة قليلًا قبل متابعة يومك كالمعتاد. يُلاحظ العديد من المرضى تحسنًا ملحوظًا في مستويات الطاقة مباشرةً بعد الجلسة.",
                    "icon": "fa-solid fa-check-circle"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد العلاج",
            "subheading": "استمتع بتحسين الأداء البدني والحيوية",
            "para": "تُقدّم جلسة تعزيز الطاقة للرجال بالتنقيط الوريدي العديد من الفوائد للرجال الذين يسعون لتعزيز صحتهم البدنية والذهنية، وتشمل:",
            "items": [
                {
                    "title": "زيادة مستويات الطاقة",
                    "desc": "يمنحك العلاج دفعة فورية من النشاط والتحمل البدني، مما يجعله مثاليًا للعاملين، ورجال الأعمال، والرياضيين.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "تحسين الأداء الرياضي",
                    "desc": "يُساعد مزيج الفيتامينات والأحماض الأمينية على تعزيز القدرة البدنية وتسريع تعافي العضلات بعد التمارين أو المجهود المكثف.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "تحسين الصفاء الذهني",
                    "desc": "تحتوي الجلسة على مضادات أكسدة فعالة تساهم في تقليل الضباب الدماغي وزيادة التركيز والانتباه.",
                    "icon": "fa-solid fa-brain"
                },
                {
                    "title": "دعم التوازن الهرموني",
                    "desc": "تحتوي التركيبة على عناصر غذائية تساهم في دعم تنظيم مستوى هرمون التستوستيرون.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "ترطيب فعال للجسم",
                    "desc": "تُوفر الجلسة ترطيبًا فوريًا عبر حقن الإلكتروليتات مباشرةً في مجرى الدم، مما يعزز الحيوية ويُحافظ على الأداء البدني.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "تعزيز الجهاز المناعي",
                    "desc": "تساعد العناصر المغذية في دعم جهاز المناعة ليبقى الجسم في حالة نشاط وصحة، حتى في فترات الضغط أو الإرهاق.",
                    "icon": "fa-solid fa-shield-alt"
                }
            ]
        },
        "eligibility": {
            "heading": "الأهلية للعلاج",
            "subheading": "",
            "para": "لا يوجد علاج يلائم الجميع، لذا يجب معرفة ما إذا كنت مرشحًا مناسبًا لجلسة تعزيز الطاقة للرجال بالتنقيط الوريدي. يُعتبر هذا العلاج مثاليًا للرجال الذين يشعرون بالإرهاق أو التوتر أو انخفاض الأداء الجسدي والذهني، وهو مصمّم خصيصًا للرجال الذين يسعون إلى تحسين طاقتهم البدنية والذهنية، ويشمل:",
            "items": [
                {
                    "title": "الرجال النشطون",
                    "desc": "معظم الرجال الراغبين في تحسين أدائهم البدني والذهني.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "من يعانون من الإرهاق",
                    "desc": "الرجال الذين يعانون من التعب أو الإرهاق المستمر.",
                    "icon": "fa-solid fa-tired"
                },
                {
                    "title": "الرياضيون",
                    "desc": "الرجال الذين يرغبون في تحسين القدرة على التحمل وتعزيز عملية التعافي.",
                    "icon": "fa-solid fa-dumbbell"
                },
                {
                    "title": "كبار السن",
                    "desc": "الرجال الذين يعانون من انخفاض مستويات الطاقة أو التستوستيرون المرتبط بتقدم العمر.",
                    "icon": "fa-solid fa-user-clock"
                },
                {
                    "title": "أصحاب المهن المجهدة",
                    "desc": "الرياضيون أو من يحتاجون إلى ترطيب سريع وفعال بعد مجهود بدني مكثف.",
                    "icon": "fa-solid fa-briefcase"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد قبل الجلسة",
            "subheading": "",
            "para": "يعد الاستعداد لجلسة تعزيز الطاقة للرجال بالتنقيط الوريدي بسيط، لكن يجب اتباع بعض الخطوات للمساعدة على تحقيق أقصى استفادة من العلاج.",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "احرص على الترطيب الجيد قبل الموعد، لتسهيل عملية إدخال الإبرة وتعزيز امتصاص العناصر الغذائية.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "تناول وجبة خفيفة",
                    "desc": "يُفضل تناول وجبة خفيفة ومتوازنة قبل الجلسة، لتجنب الشعور بالدوار أثناء الإجراء.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "تجنب الكافيين والكحول",
                    "desc": "يُنصح بالامتناع عن الكافيين والمشروبات الكحولية قبل الجلسة بعدة ساعات، لأنها قد تُسبب الجفاف.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "استشارة الطبيب",
                    "desc": "تأكد من مراجعة أي أدوية تتناولها أو حالات صحية تعاني منها مع الطاقم الطبي في العيادة، لضمان ملاءمة الجلسة لحالتك.",
                    "icon": "fa-solid fa-comment-medical"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "توفر جلسة تعزيز الطاقة للرجال بالتنقيط الوريدي فوائد فورية وتدريجية، للرجال الذين يسعون إلى تعزيز الحيوية والنشاط، حيث يلاحظ العديد من المرضى بعد الجلسة:",
            "items": [
                {
                    "title": "زيادة الطاقة",
                    "desc": "زيادة ملحوظة في مستويات الطاقة والقدرة على التحمل.",
                    "icon": "fa-solid fa-battery-three-quarters"
                },
                {
                    "title": "صفاء ذهني",
                    "desc": "تحسن الوضوح الذهني والتركيز.",
                    "icon": "fa-solid fa-lightbulb"
                },
                {
                    "title": "تعافي أسرع",
                    "desc": "تسريع عملية تعافي العضلات بعد التمارين الرياضية.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "ترطيب مثالي",
                    "desc": "ترطيب أفضل للجسم.",
                    "icon": "fa-solid fa-tint"
                },
                {
                    "title": "تحسن المزاج",
                    "desc": "تحسن الحالة المزاجية وانخفاض في مستويات التوتر.",
                    "icon": "fa-solid fa-smile"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "لتعزيز والحفاظ على فوائد علاج تعزيز الطاقة للرجال بالتنقيط الوريدي:",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "استمر في شرب كميات كافية من الماء للحفاظ على مستويات الترطيب المثالية.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "مراقبة الآثار",
                    "desc": "راقب أي آثار جانبية محتملة، والتي تُعد نادرة الحدوث.",
                    "icon": "fa-solid fa-clipboard-check"
                },
                {
                    "title": "جلسات منتظمة",
                    "desc": "فكر في الجلسات المنتظمة للحصول على فوائد مستدامة للطاقة والحيوية.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "نمط حياة صحي",
                    "desc": "حافظ على نظام غذائي متوازن وروتين تمارين رياضية لتعزيز تأثيرات العلاج.",
                    "icon": "fa-solid fa-heart"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "كم تستغرق جلسة تعزيز الطاقة للرجال؟",
                    "answer": "تستغرق عملية التسريب عادةً ما بين 30 إلى 60 دقيقة."
                },
                {
                    "question": "هل العلاج مؤلم؟",
                    "answer": "قد يشعر المرضى بوخز بسيط عند إدخال الإبرة، لكن العلاج نفسه غير مؤلم."
                },
                {
                    "question": "متى سأشعر بالنتائج؟",
                    "answer": "يذكر العديد من المرضى شعورًا بزيادة الطاقة مباشرةً بعد الجلسة."
                },
                {
                    "question": "كم مرة يجب أن أحصل على هذا العلاج؟",
                    "answer": "يعتمد التكرار على الاحتياجات الفردية - يمكن لأطبائنا تقديم توصية أثناء الاستشارة."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "الآثار الجانبية نادرة ولكن قد تشمل كدمات طفيفة في موقع الحقن أو دوار خفيف."
                }
            ]
        }
    }
}